import { type ReactNode } from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { type PickersInputLocaleText } from "@mui/x-date-pickers/locales";

type DateLocalizationProviderProps = {
  children?: ReactNode;
};

/**
 * Figma's copy where it differs from MUI's `en` text. The empty field reads `mm/dd/yyyy`, where MUI's
 * placeholders are upper-case format tokens. `ui/range-picker` titles its two fields `Start date` and
 * `End date`, where MUI's range labels are `Start` and `End`.
 */
const LOCALE_TEXT: PickersInputLocaleText = {
  fieldMonthPlaceholder: ({ contentType }) => (contentType === "letter" ? "mmmm" : "mm"),
  fieldDayPlaceholder: () => "dd",
  fieldYearPlaceholder: ({ digitAmount }) => "y".repeat(digitAmount),
  start: "Start date",
  end: "End date",
};

/**
 * Every `ui/date-picker` needs this ancestor — MUI X throws without it. Day.js because it is already the
 * app's date library; its default `en` locale is what gives the field its `MM/DD/YYYY` order.
 */
export const DateLocalizationProvider = ({ children }: DateLocalizationProviderProps) => (
  <LocalizationProvider dateAdapter={AdapterDayjs} localeText={LOCALE_TEXT}>
    {children}
  </LocalizationProvider>
);
